/**
 * Attempts to get the post ID from the body class list.
 * @returns {int} The post ID on success, or 0 on failure.
 */
const getPostId = () => Array.from(document.body.classList)
  .reduce((acc, item) => (0 === acc && item.match(/[0-9]+/)
    ? parseInt(item.match(/[0-9]+/)[0], 10)
    : acc), 0);

export default getPostId;
